import { Question } from "../types";

export const questions: Question[] = [
  // Family (3 questions)
  {
    id: 1,
    text: "Cuando crecía, la forma en que mi familia moldeó mi actitud hacia el trabajo fue…",
    category: "family",
    options: [
      {
        text: "Me enseñaron que el trabajo duro merece respeto y que ninguna tarea es inferior o indigna.",
        scores: {
          jaguar: 5.35,
          condor: 4.75,
          llama: 5.3,
          quetzal: 2.55,
          colibri: 2.65,
          coqui: 4.4,
          buho: 3.35,
        },
      },
      {
        text: "Mi familia esperaba que yo tuviera éxito no solo por mí, sino también por ellos.",
        scores: {
          jaguar: 4.8,
          condor: 4.2,
          llama: 4.75,
          quetzal: 3.65,
          colibri: 3.5,
          coqui: 5.05,
          buho: 2.75,
        },
      },
      {
        text: "Aprendí que lo más importante es hacer lo correcto, aunque me tome más tiempo.",
        scores: {
          jaguar: 2.55,
          condor: 4.8,
          llama: 4.25,
          quetzal: 3.2,
          colibri: 3.08,
          coqui: 2.85,
          buho: 5.05,
        },
      },
      {
        text: "Mi familia valoraba la independencia. Se esperaba que yo resolviera las cosas por mi cuenta.",
        scores: {
          jaguar: 5.85,
          condor: 3.8,
          llama: 2.65,
          quetzal: 3.75,
          colibri: 3.18,
          coqui: 2.05,
          buho: 2.3,
        },
      },
      {
        text: "Mis padres me dieron un ejemplo de sacrificio y resiliencia - Trato de llegar a ese ideal.",
        scores: {
          jaguar: 4.25,
          condor: 4.85,
          llama: 3.7,
          quetzal: 3.65,
          colibri: 3.45,
          coqui: 4.5,
          buho: 3.3,
        },
      },
      {
        text: "Mi crianza estuvo llena de calidez, emoción y creatividad—esas siguen siendo mis fortalezas.",
        scores: {
          jaguar: 2.65,
          condor: 2.05,
          llama: 3.2,
          quetzal: 5.35,
          colibri: 4.97,
          coqui: 3.45,
          buho: 2.3,
        },
      },
      {
        text: "Nosotros no hablábamos mucho sobre carreras profesionales; tuve que soñar y esforzarme por mi cuenta.",
        scores: {
          jaguar: 5.85,
          condor: 3.7,
          llama: 2.6,
          quetzal: 4.3,
          colibri: 4.07,
          coqui: 2.25,
          buho: 2.85,
        },
      },
    ],
  },
  {
    id: 2,
    text: "Cuando se trata de ayudar a mi familia hoy en día, generalmente…",
    category: "family",
    options: [
      {
        text: "Ayudarlos o apoyarlos económicamente siempre que pueda - Ellos hicieron tanto por mí.",
        scores: {
          jaguar: 4.2,
          condor: 5.3,
          llama: 4.75,
          quetzal: 3.1,
          colibri: 3.02,
          coqui: 5.55,
          buho: 3.35,
        },
      },
      {
        text: "Mantenerme en contacto y dedicarle tiempo a ellos, aunque yo esté lejos físicamente.",
        scores: {
          jaguar: 2.55,
          condor: 3.7,
          llama: 5.35,
          quetzal: 3.65,
          colibri: 4.07,
          coqui: 4.5,
          buho: 3.3,
        },
      },
      {
        text: "Recordarles lo orgulloso que estoy de nuestra historia y cultura.",
        scores: {
          jaguar: 2.05,
          condor: 2.6,
          llama: 3.75,
          quetzal: 5.85,
          colibri: 4.55,
          coqui: 3.4,
          buho: 2.85,
        },
      },
      {
        text: "Establecer metas grandes y mostrarles lo que es posible al alcanzarlas.",
        scores: {
          jaguar: 5.85,
          condor: 3.8,
          llama: 2.1,
          quetzal: 3.75,
          colibri: 3.18,
          coqui: 2.35,
          buho: 2.05,
        },
      },
      {
        text: "Asegurarme de que estén seguros, estables y bien cuidados, incluso si es difícil para mí.",
        scores: {
          jaguar: 3.7,
          condor: 4.85,
          llama: 3.65,
          quetzal: 2.55,
          colibri: 3.5,
          coqui: 4.5,
          buho: 3.95,
        },
      },
      {
        text: "Permitirles ser parte de mi recorrido-ellos moldearon quien soy hoy.",
        scores: {
          jaguar: 3.7,
          condor: 3.65,
          llama: 4.85,
          quetzal: 4.8,
          colibri: 4.5,
          coqui: 3.3,
          buho: 2.75,
        },
      },
      {
        text: "Repagar o retribuir ayudando a la próxima generación de mi familia a soñar en grande.",
        scores: {
          jaguar: 4.3,
          condor: 4.25,
          llama: 3.6,
          quetzal: 4.85,
          colibri: 3.97,
          coqui: 3.9,
          buho: 2.75,
        },
      },
    ],
  },
  {
    id: 3,
    text: "Cuando pienso en lo que me motiva en el trabajo…",
    category: "growth",
    options: [
      {
        text: "Quiero ganar, liderar y ser reconocido por tomar decisiones audaces.",
        scores: {
          jaguar: 6.85,
          condor: 2.2,
          llama: 1.1,
          quetzal: 3.3,
          colibri: 2.75,
          coqui: 1.65,
          buho: 1.05,
        },
      },
      {
        text: "Me siento realizado cuando inspiro a otros y les ayudo a crecer.",
        scores: {
          jaguar: 2.25,
          condor: 6.35,
          llama: 2.2,
          quetzal: 2.15,
          colibri: 2.1,
          coqui: 4,
          buho: 2.05,
        },
      },
      {
        text: "Encuentro alegría en ser confiable, estar presente de manera constante y mantener la estabilidad.",
        scores: {
          jaguar: 1.05,
          condor: 2.7,
          llama: 6.85,
          quetzal: 1.6,
          colibri: 2.15,
          coqui: 3,
          buho: 2.95,
        },
      },
      {
        text: "Me encanta compartir historias, ideas o arte que reflejen quién soy y de dónde vengo.",
        scores: {
          jaguar: 1.2,
          condor: 1.15,
          llama: 1.1,
          quetzal: 6.85,
          colibri: 2.8,
          coqui: 1.75,
          buho: 1.05,
        },
      },
      {
        text: "Me lleno de energía al conectar con las personas y mantener un ambiente positivo.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 2.15,
          quetzal: 3.8,
          colibri: 6.35,
          coqui: 2.1,
          buho: 1.05,
        },
      },
      {
        text: "Me siento responsable del bienestar emocional y de la unidad de mi equipo.",
        scores: {
          jaguar: 1.6,
          condor: 4.8,
          llama: 2.25,
          quetzal: 1.55,
          colibri: 2.2,
          coqui: 6.05,
          buho: 2.15,
        },
      },
      {
        text: "Me fascina cuando puedo reflexionar profundamente y dirigir desde detrás de escena.",
        scores: {
          jaguar: 1.1,
          condor: 2.25,
          llama: 3.3,
          quetzal: 2.2,
          colibri: 1.05,
          coqui: 2.15,
          buho: 6.55,
        },
      },
    ],
  },
  {
    id: 4,
    text: "Cuando se trata de cómo demuestro liderazgo…",
    category: "authority",
    options: [
      {
        text: "Tomo el control y tomo decisiones de manera rápida y clara.",
        scores: {
          jaguar: 6.85,
          condor: 2.8,
          llama: 1.1,
          quetzal: 1.7,
          colibri: 2.25,
          coqui: 1.65,
          buho: 1.05,
        },
      },
      {
        text: "Soy mentor y guío a otros, siempre disponible para apoyo.",
        scores: {
          jaguar: 2.25,
          condor: 6.35,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 1.55,
          coqui: 4,
          buho: 2.15,
        },
      },
      {
        text: "Lidero manteniéndome firme y dando ejemplo de consistencia.",
        scores: {
          jaguar: 1.6,
          condor: 2.2,
          llama: 6.35,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.95,
          buho: 3.5,
        },
      },
      {
        text: "Expreso visiones audaces o creativas que otros quizás no hayan considerado.",
        scores: {
          jaguar: 1.2,
          condor: 1.15,
          llama: 1.1,
          quetzal: 6.85,
          colibri: 3.3,
          coqui: 1.05,
          buho: 1.75,
        },
      },
      {
        text: "Genero energía y logro que las personas se entusiasmen y se involucren.",
        scores: {
          jaguar: 2.75,
          condor: 1.65,
          llama: 1.6,
          quetzal: 3.8,
          colibri: 6.85,
          coqui: 2.2,
          buho: 1.05,
        },
      },
      {
        text: "Escucho con atención y conecto emocionalmente a las personas.",
        scores: {
          jaguar: 1.55,
          condor: 3.3,
          llama: 2.2,
          quetzal: 2.15,
          colibri: 2.1,
          coqui: 6.05,
          buho: 2.95,
        },
      },
      {
        text: "Aporto una perspectiva tranquila y ayudo a los demás a pensar de manera crítica.",
        scores: {
          jaguar: 1.1,
          condor: 2.25,
          llama: 2.8,
          quetzal: 2.2,
          colibri: 1.05,
          coqui: 2.15,
          buho: 6.55,
        },
      },
    ],
  },
  {
    id: 5,
    text: "Cuando un miembro de la familia me pide consejo profesional, yo…",
    category: "family",
    options: [
      {
        text: "Sugiero que intenten algo nuevo o creativo.",
        scores: {
          jaguar: 1.65,
          condor: 1.1,
          llama: 1.05,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.25,
          buho: 2.2,
        },
      },
      {
        text: "Recomiendo el camino más seguro y confiable.",
        scores: {
          jaguar: 2.8,
          condor: 2.25,
          llama: 5.35,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.2,
          buho: 2.15,
        },
      },
      {
        text: "Los ayudo a generar ideas sobre cómo destacarse.",
        scores: {
          jaguar: 2.8,
          condor: 1.15,
          llama: 1.1,
          quetzal: 1.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 2.25,
        },
      },
      {
        text: "Escucho primero y pongo sus necesidades antes que mis opiniones.",
        scores: {
          jaguar: 1.6,
          condor: 2.25,
          llama: 5.35,
          quetzal: 1.55,
          colibri: 2.2,
          coqui: 4,
          buho: 2.15,
        },
      },
      {
        text: "Los guío a través de un plan o esquema para tomar decisiones.",
        scores: {
          jaguar: 1.7,
          condor: 4.3,
          llama: 2.25,
          quetzal: 1.65,
          colibri: 1.1,
          coqui: 1.05,
          buho: 5.05,
        },
      },
      {
        text: "Los animo a tomar la iniciativa y liderar.",
        scores: {
          jaguar: 5.85,
          condor: 2.25,
          llama: 1.15,
          quetzal: 2.8,
          colibri: 1.1,
          coqui: 1.05,
          buho: 2.2,
        },
      },
      {
        text: "Los conecto con alguien de mi red de contactos.",
        scores: {
          jaguar: 2.75,
          condor: 3.3,
          llama: 2.2,
          quetzal: 1.65,
          colibri: 1.1,
          coqui: 5.05,
          buho: 1.05,
        },
      },
    ],
  },
  {
    id: 6,
    text: "Cuando mi equipo está pasando por un momento difícil…",
    category: "group_loyalty",
    options: [
      {
        text: "Doy un paso adelante para impulsarnos y tomar el control.",
        scores: {
          jaguar: 6.85,
          condor: 2.8,
          llama: 1.7,
          quetzal: 1.65,
          colibri: 2.25,
          coqui: 1.1,
          buho: 1.05,
        },
      },
      {
        text: "Apoyo a otros emocionalmente y trato de mantener el ánimo alto.",
        scores: {
          jaguar: 2.25,
          condor: 4.8,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 2.15,
          coqui: 6.05,
          buho: 1.55,
        },
      },
      {
        text: "Me concentro en mis responsabilidades para mantener las cosas funcionando.",
        scores: {
          jaguar: 1.6,
          condor: 2.2,
          llama: 6.35,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.45,
          buho: 3,
        },
      },
      {
        text: "Ofrezco soluciones creativas o símbolos que nos recuerdan quiénes somos.",
        scores: {
          jaguar: 1.15,
          condor: 1.1,
          llama: 1.75,
          quetzal: 6.85,
          colibri: 3.3,
          coqui: 1.7,
          buho: 1.05,
        },
      },
      {
        text: "Aporto energía y optimismo, ayudándonos a reír o replantear.",
        scores: {
          jaguar: 2.25,
          condor: 1.65,
          llama: 1.6,
          quetzal: 3.8,
          colibri: 6.85,
          coqui: 2.2,
          buho: 1.05,
        },
      },
      {
        text: "Me comunico con las personas individualmente y les doy tranquilidad.",
        scores: {
          jaguar: 1.05,
          condor: 4.8,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 2.15,
          coqui: 5.55,
          buho: 2.95,
        },
      },
      {
        text: "Observo en silencio y ofrezco ideas estratégicas cuando es necesario.",
        scores: {
          jaguar: 1.05,
          condor: 2.3,
          llama: 2.25,
          quetzal: 1.65,
          colibri: 1.6,
          coqui: 2.2,
          buho: 6.55,
        },
      },
    ],
  },
  {
    id: 7,
    text: "Cuando trabajo en grupo…",
    category: "group_loyalty",
    options: [
      {
        text: "Tomo el liderazgo de forma natural; me gusta impulsar el progreso y organizar a los demás.",
        scores: {
          jaguar: 7,
          condor: 5.3,
          llama: 3.25,
          quetzal: 2.65,
          colibri: 2.4,
          coqui: 2.05,
          buho: 2.9,
        },
      },
      {
        text: "Me enfoco en asegurarme de que nadie se sienta excluido o ignorado.",
        scores: {
          jaguar: 2.05,
          condor: 3.15,
          llama: 5.35,
          quetzal: 4.25,
          colibri: 4.89,
          coqui: 3.9,
          buho: 2.8,
        },
      },
      {
        text: "Primero observo en silencio, buscando dónde puedo agregar valor.",
        scores: {
          jaguar: 2.1,
          condor: 4.3,
          llama: 3.15,
          quetzal: 3.75,
          colibri: 3.26,
          coqui: 2.05,
          buho: 6.05,
        },
      },
      {
        text: "Ofrezco ideas e inspiración porque quiero que todos se sientan motivados.",
        scores: {
          jaguar: 4.3,
          condor: 3.15,
          llama: 4.25,
          quetzal: 6.35,
          colibri: 4.02,
          coqui: 2.8,
          buho: 2.05,
        },
      },
      {
        text: "Busco maneras de ayudar, aún cuando no soy o estoy en el centro de atención.",
        scores: {
          jaguar: 2.05,
          condor: 3.15,
          llama: 6.35,
          quetzal: 3.75,
          colibri: 3.26,
          coqui: 5,
          buho: 2.8,
        },
      },
      {
        text: "Construyo relaciones y logro que las personas se abran y se sientan conectadas.",
        scores: {
          jaguar: 3.15,
          condor: 2.1,
          llama: 5.3,
          quetzal: 4.25,
          colibri: 5.7,
          coqui: 3.9,
          buho: 2.05,
        },
      },
      {
        text: "Me aseguro de que el grupo se mantenga enfocado y eficiente.",
        scores: {
          jaguar: 5.3,
          condor: 6.35,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 2.44,
          coqui: 2.05,
          buho: 3.95,
        },
      },
    ],
  },
  {
    id: 8,
    text: "Cuando estoy bajo presión en el trabajo…",
    category: "tenacity_drive",
    options: [
      {
        text: "Prospero; la presión saca a relucir lo mejor de mi pensamiento y energía.",
        scores: {
          jaguar: 7,
          condor: 5.3,
          llama: 2.05,
          quetzal: 3.7,
          colibri: 2.65,
          coqui: 2.85,
          buho: 3.95,
        },
      },
      {
        text: "Me enfoco en mantenerme calmado y resolver una cosa a la vez.",
        scores: {
          jaguar: 4.2,
          condor: 6.35,
          llama: 5.25,
          quetzal: 3.65,
          colibri: 3.5,
          coqui: 2.75,
          buho: 6,
        },
      },
      {
        text: "Me mantengo optimista y trato de mantener motivados a los demás también.",
        scores: {
          jaguar: 5.3,
          condor: 4.2,
          llama: 4.15,
          quetzal: 6.35,
          colibri: 4.5,
          coqui: 3.8,
          buho: 2.75,
        },
      },
      {
        text: "Me quedo en silencio y sigo adelante por mi cuenta.",
        scores: {
          jaguar: 3.25,
          condor: 4.3,
          llama: 3.2,
          quetzal: 2.6,
          colibri: 2.7,
          coqui: 2.05,
          buho: 6.7,
        },
      },
      {
        text: "Siento tensión, pero trato de no mostrarla porque no quiero poner una carga a los demás.",
        scores: {
          jaguar: 2.05,
          condor: 3.1,
          llama: 5.35,
          quetzal: 3.65,
          colibri: 4.55,
          coqui: 3.95,
          buho: 3.9,
        },
      },
      {
        text: "Pido apoyo cuando lo necesito y ofrezco lo mismo a los demás.",
        scores: {
          jaguar: 4.2,
          condor: 5.25,
          llama: 6.35,
          quetzal: 4.15,
          colibri: 5.4,
          coqui: 3.8,
          buho: 3.75,
        },
      },
      {
        text: "Actúo rápido y me esfuerzo al máximo para cumplir con las expectativas, sin importar qué.",
        scores: {
          jaguar: 6.3,
          condor: 7,
          llama: 3.15,
          quetzal: 3.7,
          colibri: 2.6,
          coqui: 4.95,
          buho: 2.8,
        },
      },
    ],
  },
  {
    id: 9,
    text: "Cuando hablo de mis logros…",
    category: "humility",
    options: [
      {
        text: "Documento las lecciones aprendidas.",
        scores: {
          jaguar: 2.25,
          condor: 4.3,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.15,
          buho: 5.05,
        },
      },
      {
        text: "Reconozco a mentores y a los que me apoyaron o ayudaron.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 3.25,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 5.05,
          buho: 2.1,
        },
      },
      {
        text: "Lo minimizo o hago una broma; me siento incómodo siendo el centro de atención.",
        scores: {
          jaguar: 1.1,
          condor: 1.05,
          llama: 3.25,
          quetzal: 1.65,
          colibri: 2.2,
          coqui: 4,
          buho: 5.05,
        },
      },
      {
        text: "Presento métricas detalladas.",
        scores: {
          jaguar: 3.3,
          condor: 2.2,
          llama: 2.15,
          quetzal: 2.75,
          colibri: 2.1,
          coqui: 1.05,
          buho: 5.05,
        },
      },
      {
        text: "Destaco mi papel de liderazgo.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.75,
          colibri: 2.2,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Me enfoco en la contribución del equipo.",
        scores: {
          jaguar: 1.05,
          condor: 2.2,
          llama: 5.35,
          quetzal: 2.75,
          colibri: 2.15,
          coqui: 4,
          buho: 2.1,
        },
      },
      {
        text: "Comparto enfoques creativos utilizados.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.1,
          buho: 2.05,
        },
      },
    ],
  },
  {
    id: 10,
    text: "En reuniones con los ejecutivos…",
    category: "humility",
    options: [
      {
        text: "Construyo relaciones colaborativas.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 3.25,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 5.05,
          buho: 2.1,
        },
      },
      {
        text: "Escucho más de lo que hablo.",
        scores: {
          jaguar: 1.05,
          condor: 2.2,
          llama: 5.35,
          quetzal: 2.75,
          colibri: 2.15,
          coqui: 4,
          buho: 2.1,
        },
      },
      {
        text: "Presento mis ideas con seguridad y confianza.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.75,
          colibri: 2.2,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Ofrezco soluciones innovadoras.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.1,
          buho: 2.05,
        },
      },
      {
        text: "Proporciono análisis detallado.",
        scores: {
          jaguar: 3.3,
          condor: 2.2,
          llama: 2.15,
          quetzal: 2.75,
          colibri: 2.1,
          coqui: 1.05,
          buho: 5.05,
        },
      },
      {
        text: "Mantengo energía positiva.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Sigo los protocolos apropiados.",
        scores: {
          jaguar: 2.25,
          condor: 4.3,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.15,
          buho: 5.05,
        },
      },
    ],
  },
  {
    id: 11,
    text: "Al recibir retroalimentación…",
    category: "humility",
    options: [
      {
        text: "Discuto cómo afecta al equipo.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Creo un plan de acción.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Lo veo como una oportunidad para la innovación.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Respondo con entusiasmo para aprender.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Lo analizo metódicamente.",
        scores: {
          jaguar: 3.25,
          condor: 2.1,
          llama: 3.2,
          quetzal: 2.65,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Lo acepto con gracia y me enfoco en la mejora.",
        scores: {
          jaguar: 2.1,
          condor: 3.25,
          llama: 5.35,
          quetzal: 2.65,
          colibri: 2.05,
          coqui: 2.9,
          buho: 4,
        },
      },
      {
        text: "Explico mi razonamiento y perspectiva.",
        scores: {
          jaguar: 5.35,
          condor: 2.2,
          llama: 1.05,
          quetzal: 3.8,
          colibri: 3.25,
          coqui: 2.15,
          buho: 2.1,
        },
      },
    ],
  },
  {
    id: 12,
    text: "Cuando alguien me pide ayuda…",
    category: "sacrifice",
    options: [
      {
        text: "Siempre digo que sí — creo en estar presente para otros.",
        scores: {
          jaguar: 3.1,
          condor: 4.2,
          llama: 6.35,
          quetzal: 3.65,
          colibri: 4.58,
          coqui: 6,
          buho: 2.75,
        },
      },
      {
        text: "Ayudo cuando puedo, pero también establezco límites saludables.",
        scores: {
          jaguar: 4.2,
          condor: 5.35,
          llama: 5.3,
          quetzal: 4.15,
          colibri: 3.66,
          coqui: 3.8,
          buho: 4.95,
        },
      },
      {
        text: "Intervengo de inmediato porque no quiero que las personas enfrenten dificultades solas.",
        scores: {
          jaguar: 4.25,
          condor: 6.35,
          llama: 4.2,
          quetzal: 4.15,
          colibri: 3.71,
          coqui: 5,
          buho: 2.75,
        },
      },
      {
        text: "Ofrezco apoyo emocional — quiero que se sientan vistos.",
        scores: {
          jaguar: 2.05,
          condor: 3.15,
          llama: 4.25,
          quetzal: 6.35,
          colibri: 5.36,
          coqui: 3.9,
          buho: 2.8,
        },
      },
      {
        text: "Trato de dar orientación para que puedan ayudarse a sí mismos.",
        scores: {
          jaguar: 5.3,
          condor: 4.2,
          llama: 4.15,
          quetzal: 5.25,
          colibri: 2.94,
          coqui: 2.8,
          buho: 6.05,
        },
      },
      {
        text: "Ayudo cuando confío en sus intenciones o causa.",
        scores: {
          jaguar: 5.35,
          condor: 5.3,
          llama: 3.15,
          quetzal: 3.7,
          colibri: 2.94,
          coqui: 2.8,
          buho: 4.95,
        },
      },
      {
        text: "Pregunto cómo puedo ayudar, luego entrego por encima de las expectativas.",
        scores: {
          jaguar: 6.3,
          condor: 7,
          llama: 4.2,
          quetzal: 4.15,
          colibri: 2.94,
          coqui: 4.95,
          buho: 3.8,
        },
      },
    ],
  },
  {
    id: 13,
    text: "Cuando me enfrento a asignaciones desafiantes…",
    category: "sacrifice",
    options: [
      {
        text: "Me mantengo positivo y enérgico.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Sigo procesos sistemáticos.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Me enfoco en lograr objetivos eficientemente.",
        scores: {
          jaguar: 5.35,
          condor: 2.15,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 4.3,
          coqui: 2.1,
          buho: 2.95,
        },
      },
      {
        text: "Adapto mi enfoque según sea necesario.",
        scores: {
          jaguar: 3.3,
          condor: 5.35,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.15,
          coqui: 2.1,
          buho: 2.05,
        },
      },
      {
        text: "Asumo responsabilidades adicionales voluntariamente.",
        scores: {
          jaguar: 1.05,
          condor: 2.15,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 4,
          buho: 2.1,
        },
      },
      {
        text: "Busco soluciones creativas.",
        scores: {
          jaguar: 2.25,
          condor: 3.3,
          llama: 2.2,
          quetzal: 5.35,
          colibri: 2.15,
          coqui: 2.1,
          buho: 2.05,
        },
      },
      {
        text: "Colaboro con miembros del equipo.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
    ],
  },
  {
    id: 14,
    text: "Al equilibrar compromisos personales y profesionales…",
    category: "sacrifice",
    options: [
      {
        text: "Establezco límites y expectativas claras.",
        scores: {
          jaguar: 5.35,
          condor: 2.15,
          llama: 1.05,
          quetzal: 3.75,
          colibri: 3.2,
          coqui: 2.1,
          buho: 4,
        },
      },
      {
        text: "Establezco rutinas estructuradas.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 3.3,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Busco apoyo cuando es necesario.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Mantengo flexibilidad y energía.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Planifico y organizo cuidadosamente.",
        scores: {
          jaguar: 3.2,
          condor: 4.3,
          llama: 3.15,
          quetzal: 2.6,
          colibri: 5.35,
          coqui: 1.05,
          buho: 3.95,
        },
      },
      {
        text: "Encuentro formas creativas de manejar ambos.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Priorizo las responsabilidades laborales primero.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 3.3,
          coqui: 2.95,
          buho: 2.05,
        },
      },
    ],
  },
  {
    id: 15,
    text: "Al interactuar con líderes más senior…",
    category: "respect",
    options: [
      {
        text: "Construyo relaciones colaborativas.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Me enfoco en comunicación precisa.",
        scores: {
          jaguar: 3.25,
          condor: 2.1,
          llama: 3.2,
          quetzal: 2.65,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Dudo en expresarme si creo que alguien podría interpretarlo de manera incorrecta.",
        scores: {
          jaguar: 1.05,
          condor: 2.2,
          llama: 3.25,
          quetzal: 1.6,
          colibri: 2.15,
          coqui: 4,
          buho: 5.05,
        },
      },
      {
        text: "Aporto energía positiva.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Muestro deferencia y sigo el protocolo.",
        scores: {
          jaguar: 1.05,
          condor: 2.15,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 2.1,
          buho: 4,
        },
      },
      {
        text: "Mantengo notas y registros detallados.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Me relaciono profesionalmente como colega.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.75,
          colibri: 2.2,
          coqui: 2.15,
          buho: 2.1,
        },
      },
    ],
  },
  {
    id: 16,
    text: "En desacuerdos con colegas…",
    category: "respect",
    options: [
      {
        text: "Me enfoco en hechos y datos.",
        scores: {
          jaguar: 3.3,
          condor: 2.2,
          llama: 2.15,
          quetzal: 2.75,
          colibri: 2.1,
          coqui: 1.05,
          buho: 5.05,
        },
      },
      {
        text: "Busco armonía y terreno común.",
        scores: {
          jaguar: 1.05,
          condor: 2.2,
          llama: 5.35,
          quetzal: 2.75,
          colibri: 2.15,
          coqui: 4,
          buho: 2.1,
        },
      },
      {
        text: "Afirmo mi posición profesionalmente.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.75,
          colibri: 2.2,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Busco compromisos innovadores.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.1,
          buho: 2.05,
        },
      },
      {
        text: "Mantengo relaciones positivas.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Facilito diálogo abierto.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 3.25,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 5.05,
          buho: 2.1,
        },
      },
      {
        text: "Documento diferentes perspectivas.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.15,
          buho: 5.05,
        },
      },
    ],
  },
  {
    id: 17,
    text: "Al dar retroalimentación a otros…",
    category: "respect",
    options: [
      {
        text: "Ofrezco alternativas inspiradoras.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Considero las dinámicas del equipo.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Mantengo un tono alentador.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Sigo un formato estructurado.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Soy directo y me enfoco en la mejora.",
        scores: {
          jaguar: 5.35,
          condor: 2.15,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 3.3,
          coqui: 2.1,
          buho: 2.95,
        },
      },
      {
        text: "Soy gentil y preservo la dignidad.",
        scores: {
          jaguar: 1.05,
          condor: 3.25,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 2.15,
          coqui: 4,
          buho: 2.1,
        },
      },
      {
        text: "Proporciono sugerencias específicas.",
        scores: {
          jaguar: 3.25,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
    ],
  },
  {
    id: 18,
    text: "Al presentar ideas en reuniones…",
    category: "communication",
    options: [
      {
        text: "Me enfoco en los puntos de acción clave.",
        scores: {
          jaguar: 5.35,
          condor: 2.15,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 4.3,
          coqui: 2.1,
          buho: 2.95,
        },
      },
      {
        text: "Mantengo la energía alta y excitante.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Facilito conversaciones inclusivas.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Comparto posibilidades inspiradoras.",
        scores: {
          jaguar: 3.3,
          condor: 3.25,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.9,
          buho: 1.05,
        },
      },
      {
        text: "Utilizo historias para generar conexión.",
        scores: {
          jaguar: 2.15,
          condor: 4.3,
          llama: 5.35,
          quetzal: 3.7,
          colibri: 1.1,
          coqui: 3.95,
          buho: 1.05,
        },
      },
      {
        text: "Proporciono análisis detallado.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Utilizo formatos estructurados.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
    ],
  },
  {
    id: 19,
    text: "En comunicación escrita…",
    category: "communication",
    options: [
      {
        text: "Utilizo un lenguaje atractivo y cautivador.",
        scores: {
          jaguar: 2.5,
          condor: 3.8,
          llama: 2.45,
          quetzal: 6.15,
          colibri: 3.23,
          coqui: 2.4,
          buho: 1.25,
        },
      },
      {
        text: "Priorizo calidez y conexión.",
        scores: {
          jaguar: 1.15,
          condor: 3.55,
          llama: 5.85,
          quetzal: 2.9,
          colibri: 1.97,
          coqui: 4.4,
          buho: 2.35,
        },
      },
      {
        text: "Uso formatos estructurados.",
        scores: {
          jaguar: 2.9,
          condor: 2.85,
          llama: 2.8,
          quetzal: 1.85,
          colibri: 2.31,
          coqui: 2.45,
          buho: 6.65,
        },
      },
      {
        text: "Enfatizo objetivos compartidos.",
        scores: {
          jaguar: 2.35,
          condor: 3.6,
          llama: 3.55,
          quetzal: 2.9,
          colibri: 1.92,
          coqui: 5.55,
          buho: 2.3,
        },
      },
      {
        text: "Mantengo un tono entusiasta.",
        scores: {
          jaguar: 2.7,
          condor: 2.65,
          llama: 2.6,
          quetzal: 3.25,
          colibri: 5.62,
          coqui: 3.7,
          buho: 1.25,
        },
      },
      {
        text: "Me enfoco en claridad y precisión.",
        scores: {
          jaguar: 3.55,
          condor: 2.35,
          llama: 2.3,
          quetzal: 2.9,
          colibri: 5.02,
          coqui: 1.15,
          buho: 4.4,
        },
      },
      {
        text: "Soy conciso y directo.",
        scores: {
          jaguar: 5.85,
          condor: 2.35,
          llama: 1.15,
          quetzal: 2.9,
          colibri: 4.04,
          coqui: 2.3,
          buho: 3.25,
        },
      },
    ],
  },
  {
    id: 20,
    text: "Al manejar conversaciones difíciles…",
    category: "communication",
    options: [
      {
        text: "Construyo confianza a través de la empatía.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 3.25,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 5.05,
          buho: 2.1,
        },
      },
      {
        text: "Sigo los protocolos apropiados.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.15,
          buho: 5.05,
        },
      },
      {
        text: "Mantengo un tono calmado y positivo.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Me enfoco en los hechos y en las soluciones.",
        scores: {
          jaguar: 3.3,
          condor: 2.2,
          llama: 2.15,
          quetzal: 2.75,
          colibri: 2.1,
          coqui: 1.05,
          buho: 5.05,
        },
      },
      {
        text: "Escucho cuidadosamente y reconozco sentimientos.",
        scores: {
          jaguar: 1.05,
          condor: 2.2,
          llama: 5.35,
          quetzal: 2.75,
          colibri: 2.15,
          coqui: 4,
          buho: 2.1,
        },
      },
      {
        text: "Encuentro maneras creativas de abordar las inquietudes.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.1,
          buho: 2.05,
        },
      },
      {
        text: "Mantengo límites profesionales.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 2.15,
          coqui: 2.1,
          buho: 2.95,
        },
      },
    ],
  },
  {
    id: 21,
    text: "Cuando alguien de mi equipo tiene dificultades para cumplir las expectativas, generalmente…",
    category: "group_loyalty",
    options: [
      {
        text: "Abordo el problema de frente y ofrezco un plan de acción.",
        scores: {
          jaguar: 6.2,
          condor: 4.5,
          llama: 1.2,
          quetzal: 2.5,
          colibri: 0.8,
          coqui: 1.2,
          buho: 1.5,
        },
      },
      {
        text: "Los entreno sobre cómo navegar las dinámicas del lugar de trabajo.",
        scores: {
          jaguar: 1,
          condor: 6,
          llama: 3.8,
          quetzal: 2.8,
          colibri: 1.2,
          coqui: 2.2,
          buho: 4.8,
        },
      },
      {
        text: "Los animo y comparto consejos de mi propia experiencia.",
        scores: {
          jaguar: 2.5,
          condor: 3,
          llama: 1.8,
          quetzal: 1.5,
          colibri: 1.2,
          coqui: 4.5,
          buho: 1.8,
        },
      },
      {
        text: "Si es necesario, escalo el problema a alguien que pueda ayudar más directamente.",
        scores: {
          jaguar: 1.2,
          condor: 2.2,
          llama: 6,
          quetzal: 0.8,
          colibri: 0.7,
          coqui: 5.5,
          buho: 1,
        },
      },
      {
        text: "Me ofrezco a ayudarles a reflexionar y entender qué está saliendo mal.",
        scores: {
          jaguar: 1,
          condor: 1.5,
          llama: 3.8,
          quetzal: 1.5,
          colibri: 1.5,
          coqui: 3.5,
          buho: 3,
        },
      },
      {
        text: "Movilizo al equipo para brindarles apoyo.",
        scores: {
          jaguar: 5.2,
          condor: 4,
          llama: 1.5,
          quetzal: 5.5,
          colibri: 0.6,
          coqui: 1.8,
          buho: 1.4,
        },
      },
      {
        text: "Intervengo silenciosamente y me ofrezco a ayudarlos sin llamar la atención.",
        scores: {
          jaguar: 2.8,
          condor: 1.5,
          llama: 6.2,
          quetzal: 1,
          colibri: 0.5,
          coqui: 5.2,
          buho: 1.5,
        },
      },
    ],
  },
  {
    id: 22,
    text: "Cuando yo soy el jefe…",
    category: "authority",
    options: [
      {
        text: "Creo un ambiente positivo.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Establezco sistemas eficientes.",
        scores: {
          jaguar: 3.3,
          condor: 2.2,
          llama: 2.15,
          quetzal: 2.75,
          colibri: 2.1,
          coqui: 1.05,
          buho: 5.05,
        },
      },
      {
        text: "Fomento la innovación.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.1,
          buho: 2.05,
        },
      },
      {
        text: "Construyo relaciones sólidas.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 3.25,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 5.05,
          buho: 2.1,
        },
      },
      {
        text: "Me enfoco en apoyar a mi equipo.",
        scores: {
          jaguar: 1.05,
          condor: 2.2,
          llama: 5.35,
          quetzal: 1.6,
          colibri: 2.15,
          coqui: 2.95,
          buho: 4,
        },
      },
      {
        text: "Implemento procedimientos claros.",
        scores: {
          jaguar: 2.25,
          condor: 4.3,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.15,
          buho: 5.05,
        },
      },
      {
        text: "Establezco expectativas claras.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.75,
          colibri: 2.2,
          coqui: 2.15,
          buho: 2.1,
        },
      },
    ],
  },
  {
    id: 23,
    text: "Al trabajar con figuras de autoridad…",
    category: "authority",
    options: [
      {
        text: "Construyo relaciones colaborativas.",
        scores: {
          jaguar: 2.5,
          condor: 3.8,
          llama: 3.75,
          quetzal: 1.75,
          colibri: 2.45,
          coqui: 5.85,
          buho: 2.4,
        },
      },
      {
        text: "Mantengo interacciones positivas.",
        scores: {
          jaguar: 2.7,
          condor: 2.65,
          llama: 2.6,
          quetzal: 3.25,
          colibri: 6.55,
          coqui: 3.7,
          buho: 1.25,
        },
      },
      {
        text: "Preparo documentación exhaustiva.",
        scores: {
          jaguar: 4,
          condor: 2.7,
          llama: 2.65,
          quetzal: 3.25,
          colibri: 2.6,
          coqui: 1.25,
          buho: 6.25,
        },
      },
      {
        text: "Muestro respeto y sigo el protocolo.",
        scores: {
          jaguar: 1.25,
          condor: 2.5,
          llama: 6.15,
          quetzal: 1.8,
          colibri: 2.45,
          coqui: 3.45,
          buho: 4.7,
        },
      },
      {
        text: "Demuestro iniciativa.",
        scores: {
          jaguar: 6.55,
          condor: 4,
          llama: 1.25,
          quetzal: 3.25,
          colibri: 2.7,
          coqui: 2.35,
          buho: 2.3,
        },
      },
      {
        text: "Sigo procedimientos establecidos.",
        scores: {
          jaguar: 2.75,
          condor: 5.2,
          llama: 2.7,
          quetzal: 1.8,
          colibri: 1.25,
          coqui: 2.35,
          buho: 6.25,
        },
      },
      {
        text: "Comparto ideas innovadoras.",
        scores: {
          jaguar: 2.55,
          condor: 2.5,
          llama: 2.45,
          quetzal: 6.15,
          colibri: 3.8,
          coqui: 2.4,
          buho: 2.35,
        },
      },
    ],
  },
  {
    id: 24,
    text: "Al implementar cambios organizacionales…",
    category: "authority",
    options: [
      {
        text: "Me aseguro de que todos se sientan apoyados.",
        scores: {
          jaguar: 1.25,
          condor: 2.5,
          llama: 6.15,
          quetzal: 1.8,
          colibri: 2.45,
          coqui: 3.45,
          buho: 4.7,
        },
      },
      {
        text: "Impulso el cambio decisivamente.",
        scores: {
          jaguar: 6.55,
          condor: 4,
          llama: 1.25,
          quetzal: 3.25,
          colibri: 2.7,
          coqui: 2.35,
          buho: 2.3,
        },
      },
      {
        text: "Fomento la adaptación creativa.",
        scores: {
          jaguar: 2.55,
          condor: 2.5,
          llama: 2.45,
          quetzal: 6.15,
          colibri: 3.8,
          coqui: 2.4,
          buho: 2.35,
        },
      },
      {
        text: "Creo planes de transición detallados.",
        scores: {
          jaguar: 4,
          condor: 2.7,
          llama: 2.65,
          quetzal: 3.25,
          colibri: 2.6,
          coqui: 1.25,
          buho: 6.25,
        },
      },
      {
        text: "Mantengo entusiasmo.",
        scores: {
          jaguar: 2.7,
          condor: 2.65,
          llama: 2.6,
          quetzal: 3.25,
          colibri: 6.55,
          coqui: 3.7,
          buho: 1.25,
        },
      },
      {
        text: "Facilito comunicación abierta.",
        scores: {
          jaguar: 2.5,
          condor: 3.8,
          llama: 3.75,
          quetzal: 1.75,
          colibri: 2.45,
          coqui: 5.85,
          buho: 2.4,
        },
      },
      {
        text: "Documento todos los procesos.",
        scores: {
          jaguar: 2.75,
          condor: 5.2,
          llama: 2.7,
          quetzal: 1.8,
          colibri: 1.25,
          coqui: 2.35,
          buho: 6.25,
        },
      },
    ],
  },
  {
    id: 25,
    text: "Al representar a mi equipo ante el liderazgo…",
    category: "authority",
    options: [
      {
        text: "Construyo puentes entre niveles.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Sigo jerarquías de reporte.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Mantengo espíritu positivo.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Abogo por las necesidades del equipo respetuosamente.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 5.35,
          quetzal: 2.75,
          colibri: 2.1,
          coqui: 4,
          buho: 2.05,
        },
      },
      {
        text: "Presento logros con seguridad y confianza.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Proporciono actualizaciones completas.",
        scores: {
          jaguar: 3.25,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Comparto soluciones innovadoras.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
    ],
  },
  {
    id: 26,
    text: "Al aprender algo nuevo en el trabajo…",
    category: "growth",
    options: [
      {
        text: "Me enfoco en aplicación rápida.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Practico hasta dominar el material nuevo.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 2.05,
          coqui: 2.95,
          buho: 4,
        },
      },
      {
        text: "Exploro usos creativos del material nuevo.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Estudio exhaustivamente el material nuevo.",
        scores: {
          jaguar: 3.25,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Mantengo entusiasmo sobre lo que estoy aprendiendo.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Comparto con otros lo que estoy aprendiendo.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Documento sistemáticamente lo que estoy aprendiendo.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
    ],
  },
  {
    id: 27,
    text: "Al buscar retroalimentación para el crecimiento…",
    category: "growth",
    options: [
      {
        text: "Pido crítica específica.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Escucho humildemente para mejorar.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 2.05,
          coqui: 2.95,
          buho: 4,
        },
      },
      {
        text: "Me mantengo abierto a sugerencias.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Busco inspiración.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Solicito métricas detalladas.",
        scores: {
          jaguar: 3.25,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Mido el progreso metódicamente.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Reúno perspectivas diversas.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
    ],
  },
  {
    id: 28,
    text: "Cuando pienso en mi futuro en el lugar de trabajo, generalmente…",
    category: "growth",
    options: [
      {
        text: "Busco caminos de crecimiento que se alineen con mi propósito.",
        scores: {
          jaguar: 3.3,
          condor: 5.75,
          llama: 2.25,
          quetzal: 1.65,
          colibri: 1.1,
          coqui: 2.2,
          buho: 1.05,
        },
      },
      {
        text: "Visualizo el tipo de líder o modelo a seguir que quiero ser.",
        scores: {
          jaguar: 3.3,
          condor: 4.75,
          llama: 2.25,
          quetzal: 1.6,
          colibri: 2.2,
          coqui: 1.05,
          buho: 2.15,
        },
      },
      {
        text: "Trabajo duro silenciosamente y dejo que mi desempeño hable por sí mismo.",
        scores: {
          jaguar: 2.2,
          condor: 2.55,
          llama: 3.3,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.95,
          buho: 4.05,
        },
      },
      {
        text: "Comparto mis sueños profesionales para inspirar a otros como yo.",
        scores: {
          jaguar: 3.3,
          condor: 2.55,
          llama: 1.1,
          quetzal: 2.7,
          colibri: 4.35,
          coqui: 2.95,
          buho: 1.05,
        },
      },
      {
        text: "Ajusto metas basándome en lo que mi familia o comunidad pueda necesitar.",
        scores: {
          jaguar: 1.1,
          condor: 2.65,
          llama: 3.3,
          quetzal: 1.65,
          colibri: 2.2,
          coqui: 5.05,
          buho: 1.05,
        },
      },
      {
        text: "Establezco metas ambiciosas y trazo cómo lograrlas.",
        scores: {
          jaguar: 5.35,
          condor: 3.7,
          llama: 1.1,
          quetzal: 1.65,
          colibri: 2.25,
          coqui: 1.05,
          buho: 2.2,
        },
      },
      {
        text: "Me enfoco en la estabilidad y en mantener lo que he construido.",
        scores: {
          jaguar: 1.1,
          condor: 2.65,
          llama: 5.35,
          quetzal: 1.65,
          colibri: 1.05,
          coqui: 2.2,
          buho: 3,
        },
      },
    ],
  },
  {
    id: 29,
    text: "Al adaptarme a cambios en el lugar de trabajo…",
    category: "growth",
    options: [
      {
        text: "Documento nuevos procesos.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Mantengo estabilidad.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 2.05,
          coqui: 2.95,
          buho: 4,
        },
      },
      {
        text: "Analizo impactos sistemáticamente.",
        scores: {
          jaguar: 3.25,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Encuentro oportunidades creativas.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Me mantengo flexible y optimista.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Apoyo las transiciones de otros.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Lidero o dirijo a otros a través del cambio.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 2.15,
          buho: 2.1,
        },
      },
    ],
  },
  {
    id: 30,
    text: "Al compartir mi origen o herencia cultural en el trabajo…",
    category: "cultural_pride",
    options: [
      {
        text: "Comparto tradiciones respetuosamente.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 2.05,
          coqui: 2.95,
          buho: 4,
        },
      },
      {
        text: "Celebro creativamente.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Documento prácticas culturales.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Conecto a otros con mi comunidad.",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Comparto con entusiasmo.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Explico contexto cultural.",
        scores: {
          jaguar: 3.25,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Destaco logros orgullosamente.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 2.15,
          buho: 2.1,
        },
      },
    ],
  },
  {
    id: 31,
    text: "Cuando mi identidad cultural es pasada por alto o malentendida en el trabajo, generalmente…",
    category: "cultural_pride",
    options: [
      {
        text: "Me apoyo en mis raíces aún más orgullosamente.",
        scores: {
          jaguar: 2.25,
          condor: 1.05,
          llama: 1.6,
          quetzal: 3.8,
          colibri: 2.2,
          coqui: 5.05,
          buho: 2.15,
        },
      },
      {
        text: "Redirijo la conversación o evito el conflicto.",
        scores: {
          jaguar: 1.1,
          condor: 2.25,
          llama: 2.8,
          quetzal: 1.65,
          colibri: 2.2,
          coqui: 1.05,
          buho: 6.05,
        },
      },
      {
        text: "Hablo y explico mi perspectiva con confianza.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.65,
          quetzal: 1.6,
          colibri: 2.25,
          coqui: 2.2,
          buho: 1.05,
        },
      },
      {
        text: "Uso formas creativas o sutiles para expresar quién soy.",
        scores: {
          jaguar: 1.1,
          condor: 2.25,
          llama: 1.65,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.2,
          buho: 1.05,
        },
      },
      {
        text: "Dejo que mi desempeño demuestre el valor que aporto.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 3.8,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.15,
          buho: 4.05,
        },
      },
      {
        text: "Trato de educar a otros calmada y respetuosamente.",
        scores: {
          jaguar: 2.2,
          condor: 5.35,
          llama: 2.75,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 3,
        },
      },
      {
        text: "Me conecto con otros que entienden y comparten valores similares.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 2.75,
          quetzal: 2.7,
          colibri: 3.3,
          coqui: 4.05,
          buho: 1.05,
        },
      },
    ],
  },
  {
    id: 32,
    text: "Al ser mentor de otros que comparten mi mismo trasfondo cultural…",
    category: "cultural_pride",
    options: [
      {
        text: "Explico matices culturales.",
        scores: {
          jaguar: 3.25,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.7,
          colibri: 5.35,
          coqui: 1.05,
          buho: 4,
        },
      },
      {
        text: "Fomento el orgullo cultural.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.7,
          colibri: 3.25,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Preservo tradiciones.",
        scores: {
          jaguar: 2.3,
          condor: 2.25,
          llama: 2.2,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 2.1,
          buho: 5.05,
        },
      },
      {
        text: "Fortalezco redes de contactos (networks).",
        scores: {
          jaguar: 2.15,
          condor: 3.3,
          llama: 3.25,
          quetzal: 2.7,
          colibri: 2.1,
          coqui: 5.05,
          buho: 2.05,
        },
      },
      {
        text: "Comparto sabiduría cuidadosamente.",
        scores: {
          jaguar: 2.15,
          condor: 2.1,
          llama: 5.35,
          quetzal: 2.7,
          colibri: 2.05,
          coqui: 2.95,
          buho: 4,
        },
      },
      {
        text: "Inspiro innovación cultural.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 2.1,
          coqui: 2.95,
          buho: 2.05,
        },
      },
      {
        text: "Celebro herencia.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
    ],
  },
  {
    id: 33,
    text: "Cuando tengo dificultades en el trabajo…",
    category: "tenacity_drive",
    options: [
      {
        text: "Me mantengo positivo y sigo adelante.",
        scores: {
          jaguar: 2.7,
          condor: 2.65,
          llama: 2.6,
          quetzal: 3.25,
          colibri: 6.55,
          coqui: 3.7,
          buho: 1.25,
        },
      },
      {
        text: "Busco y encuentro soluciones creativas.",
        scores: {
          jaguar: 2.55,
          condor: 2.5,
          llama: 2.45,
          quetzal: 6.15,
          colibri: 3.8,
          coqui: 2.4,
          buho: 2.35,
        },
      },
      {
        text: "Tomo control de mi desarrollo.",
        scores: {
          jaguar: 6.55,
          condor: 4,
          llama: 1.25,
          quetzal: 3.25,
          colibri: 2.7,
          coqui: 2.35,
          buho: 2.3,
        },
      },
      {
        text: "Persisto silenciosamente y sigo intentando.",
        scores: {
          jaguar: 1.25,
          condor: 2.5,
          llama: 6.15,
          quetzal: 1.8,
          colibri: 2.45,
          coqui: 3.45,
          buho: 4.7,
        },
      },
      {
        text: "Busco apoyo o ayuda de otros.",
        scores: {
          jaguar: 2.5,
          condor: 3.8,
          llama: 3.75,
          quetzal: 1.75,
          colibri: 2.45,
          coqui: 5.85,
          buho: 2.4,
        },
      },
      {
        text: "Analizo las causas raíz de las dificultades.",
        scores: {
          jaguar: 4,
          condor: 2.7,
          llama: 2.65,
          quetzal: 3.25,
          colibri: 2.6,
          coqui: 1.25,
          buho: 6.25,
        },
      },
      {
        text: "Creo un plan de mejora.",
        scores: {
          jaguar: 2.75,
          condor: 5.2,
          llama: 2.7,
          quetzal: 1.8,
          colibri: 1.25,
          coqui: 2.35,
          buho: 6.25,
        },
      },
    ],
  },
  {
    id: 34,
    text: "Para manejar mi crecimiento profesional…",
    category: "tenacity_drive",
    options: [
      {
        text: "Me enfoco en desempeño consistente.",
        scores: {
          jaguar: 1.25,
          condor: 2.5,
          llama: 6.15,
          quetzal: 1.8,
          colibri: 2.45,
          coqui: 3.45,
          buho: 4.7,
        },
      },
      {
        text: "Construyo redes de contactos (networking) sólidas.",
        scores: {
          jaguar: 2.5,
          condor: 3.8,
          llama: 3.75,
          quetzal: 1.75,
          colibri: 2.45,
          coqui: 5.85,
          buho: 2.4,
        },
      },
      {
        text: "Sigo planes de desarrollo.",
        scores: {
          jaguar: 2.75,
          condor: 5.2,
          llama: 2.7,
          quetzal: 1.8,
          colibri: 1.25,
          coqui: 2.35,
          buho: 6.25,
        },
      },
      {
        text: "Mantengo alta visibilidad.",
        scores: {
          jaguar: 2.7,
          condor: 2.65,
          llama: 2.6,
          quetzal: 3.25,
          colibri: 6.55,
          coqui: 3.7,
          buho: 1.25,
        },
      },
      {
        text: "Mido mi progreso sistemáticamente.",
        scores: {
          jaguar: 4,
          condor: 2.7,
          llama: 2.65,
          quetzal: 3.25,
          colibri: 2.6,
          coqui: 1.25,
          buho: 6.25,
        },
      },
      {
        text: "Busco oportunidades únicas.",
        scores: {
          jaguar: 2.55,
          condor: 2.5,
          llama: 2.45,
          quetzal: 6.15,
          colibri: 3.8,
          coqui: 2.4,
          buho: 2.35,
        },
      },
      {
        text: "Establezco metas y planes ambiciosos.",
        scores: {
          jaguar: 6.55,
          condor: 4,
          llama: 1.25,
          quetzal: 3.25,
          colibri: 2.7,
          coqui: 2.35,
          buho: 2.3,
        },
      },
    ],
  },
  {
    id: 35,
    text: "Quiero ser considerado para un ascenso en mi organización:",
    category: "tenacity_drive",
    options: [
      {
        text: "Documento mis logros cuidadosamente.",
        scores: {
          jaguar: 3.3,
          condor: 2.2,
          llama: 2.15,
          quetzal: 2.75,
          colibri: 2.1,
          coqui: 1.05,
          buho: 5.05,
        },
      },
      {
        text: "Mantengo alta visibilidad.",
        scores: {
          jaguar: 2.2,
          condor: 2.15,
          llama: 2.1,
          quetzal: 2.75,
          colibri: 5.35,
          coqui: 3,
          buho: 1.05,
        },
      },
      {
        text: "Sigo los procesos establecidos de promoción precisamente.",
        scores: {
          jaguar: 2.25,
          condor: 4.3,
          llama: 2.2,
          quetzal: 1.6,
          colibri: 1.05,
          coqui: 2.15,
          buho: 5.05,
        },
      },
      {
        text: "Espero pacientemente el reconocimiento.",
        scores: {
          jaguar: 1.05,
          condor: 2.2,
          llama: 5.35,
          quetzal: 1.6,
          colibri: 2.15,
          coqui: 2.95,
          buho: 4,
        },
      },
      {
        text: "Busco activamente oportunidades para avanzar en mi carrera.",
        scores: {
          jaguar: 5.35,
          condor: 3.3,
          llama: 1.05,
          quetzal: 2.75,
          colibri: 2.2,
          coqui: 2.15,
          buho: 2.1,
        },
      },
      {
        text: "Propongo soluciones innovadoras.",
        scores: {
          jaguar: 2.25,
          condor: 2.2,
          llama: 2.15,
          quetzal: 5.35,
          colibri: 3.3,
          coqui: 2.1,
          buho: 2.05,
        },
      },
      {
        text: "Construyo relaciones interpersonales sólidas.",
        scores: {
          jaguar: 2.2,
          condor: 3.3,
          llama: 3.25,
          quetzal: 1.55,
          colibri: 2.15,
          coqui: 5.05,
          buho: 2.1,
        },
      },
    ],
  },
];
